gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
( function () {
  'use strict';
  ( function ( $ ) {
    $(function() {
      let container = document.querySelector('.scroll-container');
      let thumbNails = gsap.utils.toArray(".tab-scroller-slide");
      var j = (thumbNails.length - 1) * 76;
      if(window.innerWidth >= 1024){ 
        thumbNails.forEach((thumb, i) => {
          thumb.style.width = window.innerWidth - 76 + "px";    
        }); 
        thumbNails.forEach((thumb, i) => {
          thumb.style.right = j + "px";  
          j = j - 76;
        });
      }
      addEventListener('resize', (event) => {
        if(window.innerWidth >= 1024){
          thumbNails.forEach((thumb, i) => {
            thumb.style.width = window.innerWidth - 76 + "px";      
          });

          j = (thumbNails.length - 1) * 76;
          thumbNails.forEach((thumb, i) => {
            thumb.style.right = j + "px";  
            j = j - 76;
          });
        }
        else{
          container.style.width = "100%";
          thumbNails.forEach((thumb, i) => {
            thumb.style.width = "100%";
            thumb.style.right = "inherit";
          });
        }
      });
      ScrollTrigger.matchMedia({
        "(min-width: 1024px)"() {
          var j = 0;
          var spaceFactor = thumbNails.length - 1;
          thumbNails.forEach((thumb, i) => {
            if(i+1 != thumbNails.length){
              let animation = gsap.timeline({paused:true});
              animation.to(thumb,{
                duration: 0.5,                 
                x: () => { return - (window.innerWidth - ((thumbNails.length - j + spaceFactor) * 76))},
                onComplete:()=>{
                  thumb.classList.add('finished');
                },
                onReverseComplete:()=>{
                  thumb.classList.remove('finished');
                }
              });
	            thumb.animation = animation;

              thumb.querySelector('.tab-scrolloer-labels').addEventListener('click',function(e){
                e.preventDefault();                
                if(thumb.classList.contains('finished')){
                  for(let x=i; x<thumbNails.length-1; x++){
                    thumbNails[x].animation.reverse();
                  }
                }
                else{
                  for(let k=0; k<i; k++){
                    thumbNails[k].animation.play();
                  }
                }
              });              
              j++;
            }
            else{
              let animation = gsap.timeline({paused:true});
              animation.to(thumbNails[j-1],{
                duration: 0.5,                 
                x: () => { return - (window.innerWidth - ((thumbNails.length - j + spaceFactor) * 76))},
                onComplete:()=>{
                  thumbNails[j-1].classList.add('finished');
                },
                onReverseComplete:()=>{
                  thumbNails[j-1].classList.remove('finished');
                }
              });
	            thumbNails[j-1].animation = animation;

              thumb.querySelector('.tab-scrolloer-labels').addEventListener('click',function(e){
                e.preventDefault();                
                if(thumbNails[j-1].classList.contains('finished')){
                  for(let x=i-1; x<thumbNails.length-1; x++){
                    thumbNails[x].animation.reverse();
                  }
                }
                else{
                  for(let k=0; k<i; k++){
                    thumbNails[k].animation.play();
                  }
                }
              });
            }
          });          
        },
      });

      /*$(document).on('click','.slide-nav-mobile',function(e){
        if(!$(this).parents('.tab-scroller-slide').hasClass('expand')){
          //$('.tab-scroller-slide').removeClass('expand');
          $(this).parents('.tab-scroller-slide').addClass('expand');
          var offset;
          offset = $(this).parents('.tab-scroller-slide').offset().top - 70;
          $('html, body').animate({
              scrollTop: offset
          }, 600, function () { });
        }
        else{
          $(this).parents('.tab-scroller-slide').removeClass('expand');
        }
      });*/
    });    
  })( jQuery );
})();